import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

import * as RoutesDefinitions from '../../../routes-definitions';
import { NewAccountStep } from '../../enums';

@Component({
	selector: 'new-account-steps',
	templateUrl: './new-account-steps.component.html',
	imports: [RouterLinkActive, RouterLink, NgTemplateOutlet, TranslatePipe]
})
export class NewAccountStepsComponent {
	@Input() currentStep: NewAccountStep = NewAccountStep.Company;

	newAccountStep = NewAccountStep;

	step1Link = RoutesDefinitions.getNewAccountCompanyFullPath();
	step3Link = RoutesDefinitions.getNewAccountValidationFullPath();

	get showStep1Link() {
		return this.currentStep !== NewAccountStep.Validation && this.currentStep >= NewAccountStep.Company;
	}

	get showStep3Link() {
		return this.currentStep === NewAccountStep.Validation;
	}
}
